import { Orders } from '../constants/orders'
import { strings } from '../context/LanguageContext/strings'

const today = new Date()
const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)

export const orderModels = {
    getOrderFilters: () => [
        {
            type: 'list',
            key: 'order_type',
            display_name: 'Order Type',
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const orderTypes = Orders.getOrderType()
                return list[0]
                    ? list.map(item => orderTypes.find(type => type.value === item)?.display)
                    : orderTypes[0]?.display
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'orderStatus',
            display_name: strings.ORDER_STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const orderStatuses = Orders.getOrderStatus()
                return list[0]
                    ? list.map(item => orderStatuses.find(s => s.value === item).display)
                    : orderStatuses[0].display
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'range',
            key: 'date_range',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_DATE,
            start_value: yesterday.toISOString(),
            end_value: today.toISOString(),
            display_value: '',
            defaultDisplayValue: '',
        },
        {
            type: 'list',
            key: 'store_id',
            display_name: strings.OPS_TOOLS_STORES_STORE_ID_LABEL,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'order_id',
            display_name: strings.OPS_TOOLS_ORDERS_ORDER_ID_LABEL,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'loyalty_id',
            display_name: strings.OPS_TOOLS_ORDERS_LOYALTY_ID,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'customer_name',
            display_name: strings.OPS_TOOLS_ORDERS_CUSTOMER_NAME_LABEL,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'transaction_status',
            display_name: strings.OPS_TOOLS_ORDERS_TRANSACTION_STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const transactionStatuses = Orders.getTransactionStatus()
                return list[0]
                    ? list.map(item => transactionStatuses.find(s => s.value === item).display)
                    : transactionStatuses[0].display
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
    ],
}
